document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-privacy-preferences]');
  if (!button) return;
  const feedback = button.parentElement.querySelector('.privacy-feedback');
  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Banner unavailable');
    await window.privacyBanner.showPreferences();
    if (feedback) feedback.hidden = true;
  } catch {
    if (feedback) feedback.hidden = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
});
